/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$('.AnnouncementBar__Wrapper.slider').flickity({
  // options
  wrapAround: true,
  autoPlay: true,
  autoPlay: 4500,
  prevNextButtons: false,
  pageDots: false,
  percentPosition: false
});



$('.quickshop-button, .quickshop-button-small').click(function(e){ 
  e.preventDefault();
  
  $('.PageOverlay').addClass('is-visible');
  
  $('.ProductItem__Wrapper').addClass('no-hover');
  
  $('html').addClass('no-scroll');
  
  var productID = $(this).attr("data-product-id");
  
//   console.log('1 ' + productID);
  
  $('.quickshop-popup[data-product-id="' + productID + '"]').addClass('show');
  
  $('.quickshop-popup .Drawer__Close, .PageOverlay.is-visible').click(function(){ 
    $('.quickshop-popup').removeClass('show');  
    $('.PageOverlay').removeClass('is-visible');
    $('.ProductItem__Wrapper').removeClass('no-hover');  
    $('html').removeClass('no-scroll');
  });
  
});

$(document).on('click', '.quickshop-button', function(e) {
  
  e.preventDefault();
  
  
  $('.PageOverlay').addClass('is-visible');
  
  $('.ProductItem__Wrapper').addClass('no-hover');
  
  $('html').addClass('no-scroll');
  
  var productID = $(this).attr("data-product-id");
  
//   console.log('2 ' + productID);
  
  $('.quickshop-popup[data-product-id="' + productID + '"]').addClass('show');
  
  $('.quickshop-popup .Drawer__Close, .PageOverlay.is-visible').click(function(){ 
    $('.quickshop-popup').removeClass('show');  
    $('.PageOverlay').removeClass('is-visible');
    $('.ProductItem__Wrapper').removeClass('no-hover');  
    $('html').removeClass('no-scroll');
  });
  
});

$('body').on('click', '.quickshop-button-small', function(e) {
  e.preventDefault();
  
  $('.PageOverlay').addClass('is-visible');
  
  $('.ProductItem__Wrapper').addClass('no-hover');
  
  $('html').addClass('no-scroll');
  
  var productID = $(this).attr("data-product-id");
  
//   console.log('3 ' + productID);
  
  $('.quickshop-popup[data-product-id="' + productID + '"]').addClass('show');
  
  $('.quickshop-popup .Drawer__Close, .PageOverlay.is-visible').click(function(){ 
    $('.quickshop-popup').removeClass('show');  
    $('.PageOverlay').removeClass('is-visible');
    $('.ProductItem__Wrapper').removeClass('no-hover');  
    $('html').removeClass('no-scroll');
  });
  
});



$(document).ready(function() {
  $('.ProductItem__ImageWrapper--withAlternateImage').on('touchstart touchend', function(e) {
//     e.preventDefault();
    $(this).find('.ProductItem__Image:not(.ProductItem__Image--alternate)').toggleClass('hover_effect');
    $(this).find('.ProductItem__Image--alternate').toggleClass('hover_effect');
    console.log('alternate');
  });
});